import React, { Children } from 'react';
import { node, oneOf } from 'prop-types';

import cx from 'classnames';

import Addon from './Addon';

const propTypes = {
  left: node,
  right: node,
  size: oneOf(['small', 'large']),
};

const CLASS_ROOT = 'input-addons';

function getAddons(addons) {
  return Children.map(
    addons,
    element =>
      // console.log(element.type.displayName, Addon.displayName) ||
      element.type && element.type.displayName === Addon.displayName ? (
        element
      ) : (
        <Addon>{element}</Addon>
      )
  );
}

const Addons = ({ children, className, left, right, size, ...other }) => {
  const classes = cx(
    CLASS_ROOT,
    {
      [`${CLASS_ROOT}--${size}`]: size,
    },
    className
  );

  return (
    <div className={classes} {...other}>
      {left && getAddons(left)}
      {children}
      {right && getAddons(right)}
    </div>
  );
};

Addons.displayName = 'Addons';
Addons.propTypes = propTypes;

export default Addons;



// WEBPACK FOOTER //
// ./src/components/Forms/Input/Addons/Addons.js